import {CalendarOutlined} from "@ant-design/icons";
import {Badge, Checkbox, Space, Typography, List} from "antd";
import {formatDate, getServiceStatus} from "../helpers/helper";

const {Text} = Typography;
export const ObjectListItem = ({obj, selectedObjects, handleObjectSelection}) => (
    <List.Item>
        <Checkbox
            checked={selectedObjects.includes(obj.id)}
            onChange={(e) => handleObjectSelection(obj.id, e.target.checked)}
        >
            <Space direction="vertical" size={2} style={{width: '100%'}}>
                <Text strong>{obj.name}</Text>
                <Text type="secondary" style={{fontSize: '12px'}}>
                    {obj.long_name || obj.district}
                </Text>
                <Space size="small">
                    <CalendarOutlined/>
                    <Text type="secondary" style={{fontSize: '12px'}}>
                        {formatDate(obj.date_last_service)}
                    </Text>
                    <Badge status={getServiceStatus(obj.date_last_service)}/>
                </Space>
                {obj.comment_last_service && (
                    <Text type="secondary" style={{fontSize: '11px'}} ellipsis>
                        {obj.comment_last_service}
                    </Text>
                )}
            </Space>
        </Checkbox>
    </List.Item>
);